export default {
  CASH: "cash",
  CHEQUE: "cheque",
};
